import { ROUTES } from './routeNames'
import auth from './middleware/auth'

import AuthenticatedLayout from '@/components/layouts/AuthenticatedLayout.vue'

import dashboardRoutes from '@/modules/dashboard/dashboardRoutes'
import settingsRoutes from '@/modules/settings/settingsRoutes'
import segmentRoutes from '@/modules/segment/segmentRoutes'
// Integration routes now live under settings (settingsRoutes.ts)
import flowRoutes from '@/modules/flow/flowRoutes'
import widgetRoutes from '@/modules/widget/widgetRoutes'
import offerRoutes from '@/modules/offer/offerRoutes'
import personalizationRoutes from '@/modules/personalization/personalizationRoutes'
import insightsRoutes from '@/modules/insights/insightsRoutes'
// Attribution routes now live under settings (settingsRoutes.ts)
import onboardingRoutes from '@/modules/onboarding/onboardingRoutes'
import templateRoutes from '@/modules/template/templateRoutes'
import splittestingRoutes from '@/modules/splittesting/splittestingRoutes'
import visitorsRoutes from '@/modules/visitors/visitorsRoutes'
import pagesRoutes from '@/modules/pages/pagesRoutes'
export default [
  {
    name: ROUTES.HOME,
    path: '/',
    component: { render: () => null },
    beforeEnter: async (to, from, next) => {
      const authStore = useAuthStore()
      authStore.postLogin()
      next()
    },
    meta: { middleware: [auth] }
  },
  {
    name: ROUTES.OAUTH_CONTINUE,
    path: '/oauth/continue',
    component: () => import('@/modules/user/pages/OAuthContinue.vue'),
    meta: { middleware: [auth] }
  },

  {
    name: ROUTES.LOGIN,
    path: '/login',
    component: () => import('@/modules/user/pages/Login.vue'),
    beforeEnter: async (_, __, next) => {
      const authStore = useAuthStore()
      // Redirect authenticated users to dashboard
      if (authStore.isAuthenticated) {
        next({ name: ROUTES.DASHBOARD })
      } else {
        next()
      }
    }
  },
  {
    name: ROUTES.FORGOTPASSWORD,
    path: '/forgot-password',
    component: () => import('@/modules/user/pages/ForgotPassword.vue')
  },
  {
    name: ROUTES.RESETPASSWORD,
    path: '/reset-password',
    component: () => import('@/modules/user/pages/ResetPassword.vue')
  },
  {
    name: ROUTES.LOGOUT,
    path: '/logout',
    component: { render: () => null },
    beforeEnter: async (_, __, next) => {
      const authStore = useAuthStore()
      authStore.logout()
      next({ name: ROUTES.LOGIN })
    }
  },
  {
    name: ROUTES.REGISTER,
    path: '/register',
    alias: '/register/success',
    component: () => import('@/modules/user/pages/Register.vue'),
    beforeEnter: async (_, __, next) => {
      const authStore = useAuthStore()
      // Redirect authenticated users to dashboard
      if (authStore.isAuthenticated) {
        next({ name: ROUTES.DASHBOARD })
      } else {
        next()
      }
    }
  },
  {
    name: ROUTES.AGENCY_SIGNUP,
    path: '/agencyOnboard/:agencySlug',
    component: () => import('@/modules/user/pages/AgencyRegister.vue'),
    beforeEnter: async (_, __, next) => {
      const authStore = useAuthStore()
      // Redirect authenticated users to dashboard
      if (authStore.isAuthenticated) {
        next({ name: ROUTES.DASHBOARD })
      } else {
        next()
      }
    }
  },
  {
    name: ROUTES.ACCEPTINVITATION,
    path: '/accept',
    component: () => import('@/modules/user/pages/AcceptInvitation.vue')
  },
  {
    name: ROUTES.SETUPBLANKUSER,
    path: '/setup',
    component: () => import('@/modules/user/pages/SetupBlankUser.vue')
  },
  {
    path: '/:teamPid',
    component: AuthenticatedLayout,
    meta: { middleware: [auth] },
    children: [
      ...onboardingRoutes,
      ...dashboardRoutes,
      ...settingsRoutes,
      ...segmentRoutes,
      ...flowRoutes,
      ...widgetRoutes,
      ...offerRoutes,
      ...personalizationRoutes,
      ...insightsRoutes,
      ...templateRoutes,
      ...splittestingRoutes,
      ...visitorsRoutes,
      ...pagesRoutes,
      // Backward-compat redirects for routes moved under settings
      {
        path: 'integrations',
        redirect: (to: any) => ({ name: ROUTES.INTEGRATIONS, params: { teamPid: to.params.teamPid } })
      },
      {
        path: 'integrations/:integration',
        redirect: (to: any) => ({
          name: ROUTES.INTEGRATION,
          params: { teamPid: to.params.teamPid, integration: to.params.integration }
        })
      },
      {
        path: 'attribution',
        redirect: (to: any) => ({ name: ROUTES.ATTRIBUTION, params: { teamPid: to.params.teamPid } })
      },
      {
        path: '/:teamPid/:pathMatch(.*)*',
        name: ROUTES.NOTFOUNDAUTH,
        component: () => import('@/components/pages/NotFound.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: ROUTES.NOTFOUND,
    component: () => import('@/components/pages/NotFound.vue')
  }
]
